// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/inventory-order.less
// module id = 3510
// module chunks = 0